import { PolicyTypeEnum } from '@Policy/utils/constants';
import { EnableDisableEnum } from '@Policy/utils/types';
import {
  ConditionDefinition,
  CorrelatedExpressionShallow,
  CorrelatedRuleAggressivity,
  CorrelatedRuleShallow,
} from './types';

export enum CorrelatedTemplate {
  rules = 'rules',
  expressions = 'expressions',
}

export enum CorrelatedTemplateUrl {
  rules = '/policy/global-settings/correlated-rule-list',
  expressions = '/policy/global-settings/detection-signal-list',
}

export const AllAggressivity = 3 as const;

export const aggressivityFilterOptions = [
  AllAggressivity,
  CorrelatedRuleAggressivity.Moderate,
  CorrelatedRuleAggressivity.Aggressive,
  CorrelatedRuleAggressivity.SuperAggressive,
] as const;

export const aggressivityFilterI18nKeyMap = {
  [AllAggressivity]: 'common.label.all',
  [CorrelatedRuleAggressivity.Moderate]:
    'globalSetting.correlatedRules.moderate',
  [CorrelatedRuleAggressivity.Aggressive]:
    'globalSetting.correlatedRules.aggressive',
  [CorrelatedRuleAggressivity.SuperAggressive]:
    'globalSetting.correlatedRules.extraAggressive',
} as const;

export const filterSocialGraphExpressions = (
  expressions: CorrelatedExpressionShallow[],
  socialGraphEnabled: boolean
) => {
  return expressions?.filter((exp) => {
    if (exp?.raiExpMarkers?.includes('social_graph')) {
      return socialGraphEnabled;
    }
    return true;
  });
};

export const filterSocialGraphConditions = (
  conditions: ConditionDefinition[],
  socialGraphEnabled: boolean
) => {
  return conditions?.filter((condition) => {
    if (condition?.raiCondMarker === 'social_graph') {
      return socialGraphEnabled;
    }
    return true;
  });
};

export const filterSocialGraphRules = (
  rules: CorrelatedRuleShallow[],
  socialGraphEnabled: boolean,
  policyType?: PolicyTypeEnum
) => {
  return rules?.filter((rule) => {
    if (rule?.raiSocialGraphEnabled === EnableDisableEnum.enabled) {
      if (
        policyType &&
        [
          PolicyTypeEnum.Gmail,
          PolicyTypeEnum.ExchangeInline,
          PolicyTypeEnum.GmailInline,
        ].includes(policyType)
      ) {
        return false; // Gmail and Inline does not support social graph
      }
      return socialGraphEnabled;
    }
    return true;
  });
};

export const toLowerCaseExceptAbbreviation = (str: string) => {
  const result = str.replace(
    /([A-Z]{2,})|([A-Z][a-z]+)/g,
    (match, p1: string, p2: string) => {
      if (p1) {
        return p1; // abbreviation, keep as is
      }
      if (p2) {
        return p2.toLocaleLowerCase(); // normal word, convert to lowercase
      }
      return match;
    }
  );
  return result;
};
